<template>
  <v-dialog persistent v-model="dialog" width="600" scrollable>
    <v-card v-if="dialog">
      <v-card-title>
        Programacao de pagamento da OM {{ ordem.id }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <template v-if="ordem.data_vencimento_programada">
          <v-text-field
            disabled
            label="Data Programada Vencto/Pgto"
            :value="dataLegada"
            hint="Data informada antes da implementação da programação de pagamento"
            persistent-hint
          />
        </template>
        <template v-else>
          <v-progress-linear indeterminate color="primary" v-if="loading" />
          <template v-else>
            <v-text-field
              class="mt-4"
              outlined
              readonly
              dense
              label="Saldo a programar"
              :value="money(saldo)"
              :hint="`Total da ordem: ${money(totalOrdem)}`"
              persistent-hint
              :error="saldo != 0"
              :prefix="saldo < 0 ? '-' : '+'"
            />
            <programacao-pagamento-linha
              v-for="(prog, i) in programacao"
              :programacao="prog"
              :situacao="ordem.situacao"
              :key="`prog-${i}`"
              @input="change(i, $event)"
              @remove="remover($event)"
            />
            <v-alert type="warning" v-if="programacao.length == 0"
              >Nenhuma programação de pagamento inserida</v-alert
            >
          </template>
        </template>
      </v-card-text>
      <v-card-actions v-if="['A', 'B'].indexOf(ordem.situacao) > -1">
        <v-spacer />
        <v-btn text @click="dialog = false" depressed>
          CANCELAR
        </v-btn>
        <v-btn color="secondary" depressed @click="novo()">
          <v-icon left>mdi-calendar-plus</v-icon>
          NOVO PAGAMENTO
        </v-btn>
        <v-btn color="primary" depressed :disabled="!valido" @click="salvar()">
          SALVAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import ProgramacaoPagamentoLinha from "./ProgramacaoPagamentoLinha";
import { build, unmaskDecimal } from "../../lib/masks";
export default {
  components: { ProgramacaoPagamentoLinha },
  data() {
    return {
      loading: false,
      programacao: [],
      totalOrdem: 0,
    };
  },
  computed: {
    dialog: {
      set(val) {
        if (!val) {
          this.programacao = [];
          this.$store.commit("ordemMedicao/setProgramacaoPagamento", null);
        }
      },
      get() {
        return (
          this.$store.state.ordemMedicao.dialogProgramacaoPagamento != null
        );
      },
    },
    dataLegada() {
      return moment(this.ordem.data_vencimento_programada).format("DD/MM/YYYY");
    },
    saldo() {
      let programado = 0;
      this.programacao.map((prg) => {
        programado += parseFloat(unmaskDecimal(prg.valor));
        return prg;
      });
      return this.totalOrdem - programado;
    },
    valido() {
      let datasOK = true;
      this.programacao.map((prg) => {
        datasOK = datasOK && prg.data != "";
        return prg;
      });
      return (
        this.saldo == 0 &&
        this.programacao.length > 0 &&
        !this.loading &&
        datasOK
      );
    },
    ...mapState({
      ordem: (state) => state.ordemMedicao.dialogProgramacaoPagamento,
    }),
  },
  methods: {
    novo() {
      this.programacao.push({
        data: "",
        valor: "",
        antecipado: false,
      });
    },
    change(i, prog) {
      this.programacao = this.programacao.map((p, idx) => {
        if (idx == i) {
          return prog;
        }
        return p;
      });
    },
    remover(prg) {
      const p = this.programacao.find(
        (val) =>
          val.data == prg.data &&
          val.valor == prg.valor &&
          val.antecipado == prg.antecipado
      );

      const idx = this.programacao.indexOf(p);
      if (idx > -1) {
        this.programacao.splice(idx, 1);
      }
    },
    async carregarTotal() {
      try {
        this.loading = true;
        this.totalOrdem = await this.$store.dispatch(
          "ordemMedicao/totalOrdem",
          this.ordem
        );
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async salvar() {
      try {
        this.loading = true;
        await this.$store.dispatch("ordemMedicao/gravar", {
          id: this.ordem.id,
          programacao_pagamento: this.programacao.map((prg) => {
            return {
              data: prg.data,
              antecipado: prg.antecipado,
              valor: parseFloat(unmaskDecimal(prg.valor)),
            };
          }),
        });
        this.dialog = false;
        this.$emit("change");
        this.$store.commit("ui/setSnackbar", {
          text: "Programação de pagamento salva com sucesso!",
          color: "success",
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    money(val) {
      return build.money(Math.abs(val));
    },
  },
  watch: {
    ordem(val) {
      if (val) {
        this.carregarTotal();
        this.programacao = this.ordem.programacao_pagamento || [];
      }
    },
  },
};
</script>
